import { images } from '../constants';
import { FaSeedling, FaFireFlameCurved, FaMugHot } from 'react-icons/fa6';

const process = [ 
    {
        id: 1,
        image: images.step1,
        icon: <FaSeedling />,
        title: 'Sourcing',
        content: 'We carefully source high-quality coffee beans from sustainable farms around the world.',
    },
    {
        id: 2,
        image: images.step2,
        icon: <FaFireFlameCurved />,
        title: 'Roasting',
        content: 'Our beans are roasted to perfection, bringing out the unique flavors and aroma in each batch.',
    },
    {
        id: 3,
        image: images.step3,
        icon: <FaMugHot />,
        title: 'Brewing',
        content: 'We brew your coffee using the best techniques to ensure every cup is rich, flavorful, and fresh.',
    },
];

export default process;